import * as navigate from 'app/area/shared/navigation';
import { HttpStatusCodes } from 'app/infrastructure/remote-data';
import { ApplicationState } from 'app/types-store';
import { createDescriptionSelector } from 'app/infrastructure/translate';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { routeConstants } from 'app/routes/route-constants';
import { textCollection } from 'app/constants';

interface BlockAccessParams {
  dispatch: any;
  getState: () => ApplicationState;
  area: keyof typeof textCollection;
  translationId?: number;
  blockAccessText?: string;
}

export const getErrorMessage = (blockAccessParams: BlockAccessParams): string => {
  const { getState, translationId, area, blockAccessText } = blockAccessParams;

  if (blockAccessText) {
    return blockAccessText;
  }

  const areaState = getState()[area];

  const translate = createDescriptionSelector(areaState.texts);

  return translate(translationId);
};

export const blockAccess = (blockAccessParams: BlockAccessParams) => {
  const { dispatch, getState } = blockAccessParams;

  const errorMessage = getErrorMessage(blockAccessParams);

  const isErrorNotificationUnique = getState().app.messages
    && getState().app.messages.find(message => message.message === errorMessage) === undefined;

  if (isErrorNotificationUnique) {
    dispatch(new ErrorNotification(errorMessage));
  }

  if (window.location.pathname !== routeConstants.startupView) {
    navigate.toStartupView();
  }
};

export const isForbiddenStatus = (err) => err && err.response && err.response.status === HttpStatusCodes.FORBIDDEN;

export const isBadRequest = (err) => err && err.response && err.response.status === HttpStatusCodes.BAD_REQUEST;

export const isNotAcceptable = (err) => err && err.response && err.response.status === HttpStatusCodes.NOT_ACCEPTABLE;

export const isNotFoundStatus = (err) => err && err.response && err.response.status === HttpStatusCodes.NOT_FOUND;

export const isUnprocessableEntity = (err) => err?.response?.status === HttpStatusCodes.UNPROCESSABLE_ENTITY;
